export default __webpack_public_path__ + "static/media/northernlights.59947100.mp4";